import { BeastStats } from '../playbook/core/beast/Beast';
import { ChosenControls, ChosenStats } from '../playbook/core/chosen/Chosen';
import {
  DevotedControls,
  DevotedStats,
} from '../playbook/core/devoted/Devoted';
import {
  InfamousControls,
  InfamousStats,
} from '../playbook/core/infamous/Infamous';
import {
  NatureWitchControls,
  NatureWitchStats,
} from '../playbook/core/natureWitch/NatureWitch';
import { ScoundrelButton } from '../playbook/core/scoundrel/Scoundrel';
import { SeekerStats } from '../playbook/core/seeker/Seeker';
import { SpookyWitchButton } from '../playbook/core/spookyWitch/SpookyWitch';
import { TricksterStats } from '../playbook/core/trickster/Trickster';
import { DreamMirrorStats } from '../playbook/al&l/dreamMirror/DreamMirror';
import { EnsembleStats } from '../playbook/al&l/ensemble/Ensemble';
import { LegionStats } from '../playbook/al&l/legion/Legion';
import { NagaStats } from '../playbook/al&l/naga/Naga';
import { SunHandStats } from '../playbook/al&l/sunHand/SunHand';

import { useStoreState } from 'pullstate';
import { CharacterStore } from '../../stores/characterStore';

const playbookButton = {
  scoundrel: ScoundrelButton,
  'spooky witch': SpookyWitchButton,
};

const playbookControls = {
  chosen: ChosenControls,
  devoted: DevotedControls,
  infamous: InfamousControls,
  'nature witch': NatureWitchControls,
};

const playbookStats = {
  beast: BeastStats,
  chosen: ChosenStats,
  devoted: DevotedStats,
  infamous: InfamousStats,
  'nature witch': NatureWitchStats,
  seeker: SeekerStats,
  trickster: TricksterStats,
  'dream mirror': DreamMirrorStats,
  ensemble: EnsembleStats,
  legion: LegionStats,
  naga: NagaStats,
  'sun hand': SunHandStats,
};

export function hasPlaybookButton(playbook) {
  return Boolean(playbookButton[playbook]);
}

export function PlaybookButton(props) {
  const playbook = useStoreState(CharacterStore, s => s.playbook);
  const PlaybookButton = playbookButton[playbook];
  if (!playbook || !PlaybookButton) {
    return null;
  }

  return <PlaybookButton {...props} />;
}

export function hasPlaybookControls(playbook) {
  return Boolean(playbookControls[playbook]);
}

export function PlaybookControls(props) {
  const playbook = useStoreState(CharacterStore, s => s.playbook);
  const PlaybookControls = playbookControls[playbook];
  if (!playbook || !PlaybookControls) {
    return null;
  }

  return <PlaybookControls {...props} />;
}

export function hasPlaybookStats(playbook) {
  return Boolean(playbookStats[playbook]);
}

export function PlaybookStats(props) {
  const playbook = useStoreState(CharacterStore, s => s.playbook);
  const PlaybookStats = playbookStats[playbook];
  if (!playbook || !PlaybookStats) {
    return null;
  }

  return <PlaybookStats {...props} />;
}
